<h2 class="page-header">{{ PRODUCTS.PROJECTBORDEN }}</h2>
<div *ngIf="productSizes == null">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</div>
<div class="flex-table" *ngIf="productSizes != null">
  <div class="flex-header-row">
    <div class="flex-table-cell flex-1">
      H (cm)
      <text-field-filter
        [filterObject]="getFilterForKey('height')"
        [width]="40"
        (filterValueChanged)="onFilterValueChange($event)"
      ></text-field-filter>
    </div>
    <div class="flex-table-cell flex-1">
      B (cm)
      <text-field-filter
        [filterObject]="getFilterForKey('width')"
        [width]="40"
        (filterValueChanged)="onFilterValueChange($event)"
      ></text-field-filter>
    </div>
    <div class="flex-table-cell flex-3">Type bord</div>
    <div class="flex-table-cell flex-2 center">Type plaatsing</div>
    <div class="flex-table-cell flex-2 center">Hoogte</div>
    <div class="flex-table-cell flex-2">Materiaal</div>
    <div class="flex-table-cell flex-2">Ontwerp (min)</div>
    <div class="flex-table-cell flex-2">Plaatsing (min)</div>
    <div class="flex-table-cell flex-2">Weghalen (min)</div>
    <div class="flex-table-cell flex-2">Schilderen (€)</div>
    <div class="flex-table-cell flex-2">Aanmaak (€)</div>
    <div class="flex-table-cell flex-2">Aanmaak Retail (€)</div>
    <div class="flex-table-cell flex-2">Plaatsing (€)</div>
    <div class="flex-table-cell flex-2">Plaatsing Retail (€)</div>
    <div class="flex-table-cell flex-2">Transport (€/km)</div>
    <div class="flex-table-cell flex-2">Weghalen (€)</div>
    <div class="flex-table-cell flex-2">Recycleren (€)</div>
    <div class="flex-table-cell flex-1"></div>
  </div>
  <div
    class="flex-table-row"
    *ngFor="let productSize of productSizes; index as i"
    (click)="editProductSize(productSize, i)"
  >
    <div class="flex-table-cell flex-1">{{ productSize.height }}</div>
    <div class="flex-table-cell flex-1">{{ productSize.width }}</div>
    <div
      class="flex-table-cell ellipse flex-3"
      matTooltip="{{ productSize.boardType.label }}"
    >
      {{ productSize.boardType.label }}
    </div>
    <div
      class="flex-table-cell ellipse flex-2 center"
      matTooltip="{{ productSize.placementType.label }}"
    >
      {{ productSize.placementType.label }}
    </div>
    <div class="flex-table-cell flex-2 center">
      {{ productSize.cmToBottom }}
    </div>
    <div
      class="flex-table-cell ellipse flex-2"
      matTooltip="{{ productSize.material.name }}"
    >
      {{ productSize.material.name }}
    </div>
    <div class="flex-table-cell flex-2">{{ productSize.designerMinutes }}</div>
    <div class="flex-table-cell flex-2">{{ productSize.placerMinutes }}</div>
    <div class="flex-table-cell flex-2">{{ productSize.removalMinutes }}</div>
    <div class="flex-table-cell flex-2">
      {{ productSize.paintedPostsPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.productionPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.productionRetailPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.placementPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.placementRetailPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.transportPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.removalPrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-2">
      {{ productSize.recyclePrice | asFormatDecimal : true : 2 }}
    </div>
    <div class="flex-table-cell flex-1" (click)="$event.stopPropagation()">
      <mat-menu #actionMenu="matMenu" class="table-text">
        <button
          mat-menu-item
          (click)="duplicate(productSize)"
          class="center-text"
        >
          Dupliceren
        </button>
        <button
          mat-menu-item
          (click)="editProductSize(productSize, i)"
          class="center-text"
        >
          Aanpassen
        </button>
        <button
          mat-menu-item
          (click)="delete(productSize, i)"
          class="center-text"
        >
          Verwijderen
        </button>
      </mat-menu>
      <mat-icon class="fa-2x clickable" [matMenuTriggerFor]="actionMenu"
        >more_vert</mat-icon
      >
    </div>
  </div>
</div>
<div class="pull-left clickable" (click)="addProductSize()">
  <mat-icon svgIcon="add"></mat-icon>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
></mat-paginator>
